import _ from "lodash";
import {PRODUCT_DETAIL_KEY} from "../constants/pod.constant";

export {
    prepareParentProductsForAddOrUpdate
};

const prepareParentProductsForAddOrUpdate = (latestParentProductsList, existingParentProductsList) => {
    const processedParentProducts = {
        add: [],
        update: []
    };

    const existingParentProductsMap = _.keyBy(existingParentProductsList, PRODUCT_DETAIL_KEY.KEY);

    _.forEach(latestParentProductsList, (latestParentProduct, index) => {
        const existingParentProduct = existingParentProductsMap[latestParentProduct[PRODUCT_DETAIL_KEY.KEY]];

        if (_.isEmpty(existingParentProduct)) {
            processedParentProducts.add.push(latestParentProduct);
        } else {
            const updateNeeded = prepareExistingParentProductForUpdate(existingParentProduct, latestParentProduct);

            if (updateNeeded) {
                processedParentProducts.update.push(existingParentProduct);
            }
        }
    });

    console.log('Add Parent Products -> : ', processedParentProducts.add.length);
    console.log('Update Parent Products -> : ', processedParentProducts.update.length);

    return processedParentProducts;
}

const prepareExistingParentProductForUpdate = (existingParentProduct, latestParentProduct) => {
    let updateNeeded = false;
    latestParentProduct.id = existingParentProduct.id;

    _.forIn(latestParentProduct, (value, attribute) => {
        if (attribute !== 'id') {
            // existingParentProduct[attribute] = value;
            if (existingParentProduct.hasOwnProperty(attribute)) {
                if (_.isArray(existingParentProduct[attribute])) {
                    const existingListMap = _.keyBy(existingParentProduct[attribute], 'name');
                    const latestListMap = _.keyBy(value, 'name');
                    const mergedListMap = _.merge(latestListMap, existingListMap);
                    const mergedList = _.values(mergedListMap);
                    console.log(latestParentProduct.name, {
                        value,
                        existingListMap,
                        latestListMap,
                        mergedListMap,
                        mergedList
                    });

                    existingParentProduct[attribute] = mergedList;
                    updateNeeded = true;
                } else if (existingParentProduct[attribute] !== value) {
                    existingParentProduct[attribute] = value;
                    updateNeeded = true;
                }
            } else {
                existingParentProduct[attribute] = value;
                updateNeeded = true;
                console.log('NEW: ', attribute, ' - ', value);
            }
        }
    });

    return updateNeeded;
}
